// extracted by mini-css-extract-plugin
export default {"thumb":"custom-thumb_thumb__A58gL","isDragged":"custom-thumb_isDragged__aO9S4","value":"custom-thumb_value__QoqoE","withLabel":"custom-thumb_withLabel__8BYk4"};